import React from "react";
import { Button, Icon } from "antd";
import style from "./index.module.scss";
import { exportSignInStu } from "service/signIn";
import { SignType } from "service/signIn";

interface ExportBtnProps {
    signInId: number;
    percentage: string;
    type?: SignType;
}

export default function ExportBtn({
    signInId,
    percentage,
    type
}: ExportBtnProps) {
    return (
        <div className={style.root}>
            <div className={style.text}>出勤率 {percentage}</div>

            <Button
                className={style.button}
                type="primary"
                ghost
                onClick={() => exportSignInStu(signInId, type)}>
                <Icon type="cloud-download" /> 导出数据
            </Button>
        </div>
    );
}
